<template>
  <div class="w-full h-full">
    <v-map :zoom="zoom" :center="center" ref="map" id="map" :options="options" :maxBounds="maxBounds">
      <v-tilelayer :url="url" :attribution="attribution"></v-tilelayer>
         <v-marker :lat-lng="location.position" v-for="(location,index) in locations" :key="index">
           <v-popup class="leading-loose" :content="formatPopup(location)"></v-popup>
         </v-marker>
    </v-map>
  </div>
</template>

<script>
  import Vue2Leaflet from 'vue2-leaflet'
  import L from 'leaflet'
  require('leaflet-sleep')
  require('@leaflet/leaflet.css')

  delete L.Icon.Default.prototype._getIconUrl
  L.Icon.Default.imagePath = ''
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('@leaflet/images/marker-icon-2x.png'),
    iconUrl: require('@leaflet/images/marker-icon.png'),
    shadowUrl: require('@leaflet/images/marker-shadow.png')
  })

  export default {
    components: {
      'v-map':  Vue2Leaflet.LMap,
      'v-tilelayer':  Vue2Leaflet.LTileLayer,
      'v-marker': Vue2Leaflet.LMarker,
      'v-popup': Vue2Leaflet.LPopup,
    },
    props: ['defaultCategory'],
    data() {
      return {
        maxBounds: L.latLngBounds([[30.06, -99.16], [30.02, -99.12]]),
        zoom: 16,
        center: [30.0474688, -99.1405684],
        url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
        locations: [],
        options: {
          attributionControl: false,
          inertia: false
        }
      }
    },
    created() {
      this.getLocations(this.defaultCategory)
      let self = this
      window.events.$on('updateCategory', category => {
        self.locations.map(() => {
            self.closePopups()
        })
        this.getLocations(category)
      })
      window.events.$on('selectLocation', selected => {
        self.locations.map((location) => {
          if (location.lat == selected.lat && location.lon == selected.lon) {
            self.center = [selected.lat, selected.lon]
            self.togglePopup(location)
          }
        })
      })
    },
    methods: {
      getLocations(category) {
        axios.get('/api/v1/category/' + category)
        .then(({data}) => {
          data.locations.map((location) => {
            location.position = this.getCoords(Number(location.lat), Number(location.lon))
          })
          this.locations = data.locations
        })
      },
      getCoords(lat, lon) {
        if (lat && lon) {
          return L.latLng(lat, lon)
        }
      },
      togglePopup(location) {
        let targets = this.$refs.map.mapObject._targets
        Object.entries(targets).forEach(([key, val]) => {
          if (targets[key]._latlng == location.position) {
            targets[key].togglePopup()

          }
        })
      },
      closePopups() {
        let targets = this.$refs.map.mapObject._targets
        Object.entries(targets).forEach(([key, val]) => {
          if (targets[key].hasOwnProperty('_latlng')) {
            if (targets[key].isPopupOpen()) {
              targets[key].closePopup()
            }
          }
        })
      },
      formatPopup(location) {
        let popup = '<a href="/explore/' + location.id + '/' + location.slug + '" class="no-underline text-grey-darker">'
        popup += '<strong class="block text-black">' + location.name + '</strong>'
        popup += '<span class="block my-px text-grey-darker">'
        popup += location.address_number ? location.address_street + ', ' + location.address_number : location.address_street
        popup += '</span>'
        popup += location.phone ? '<span class="block my-px text-grey-darker">' + location.phone + '</span>' : ''
        popup += '</a>'
        return popup
      },
      scrollLocation(location) {
        window.events.$emit('scrollLocation', location);
      }
    }
  }
</script>

<style>
  .vue2leaflet-map {
    z-index: 1;
  }
</style>
